export default "__VITE_ASSET__CIEq1dep__"